import { Skeleton, Typography } from '@mui/material';
import { RecipeCustomerUserManage } from 'common/src/api/models/recipe-customer-user-manage.models';
import { CfDataGridTableViewDefinitions } from '../../../../cf-ui/DataGrid/CfDataGridProps';

export const recipeEditorsTableView = (): CfDataGridTableViewDefinitions<RecipeCustomerUserManage> => {
  return {
    xs: {
      showHeader: false,
      bodyTableRowProps: () => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      }),

      columns: [
        {
          title: '',
          width: '100%',
          value: function LocationName(props) {
            return (
              <Typography variant='responsiveParagraph' textAlign='left'>
                {props.item.UserDisplay}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton variant='rectangular' width='100%' />,
        },
      ],
    },
  };
};
